export const goAnchor = (anchorName) => {
  if (anchorName) {
    setTimeout(() => {
      let target = document.getElementById(anchorName);
      target.scrollIntoView();
    }, 800);
  }
};

export const getRandomArr = (arr, count) => {
  //随机抽取
  var shuffled = arr.slice(0),
    i = arr.length,
    min = i - count,
    temp,
    index;
  while (i-- > min) {
    //打乱数组
    index = Math.floor((i + 1) * Math.random());
    temp = shuffled[index];
    shuffled[index] = shuffled[i];
    shuffled[i] = temp;
  }
  return shuffled.slice(min);
};
